import React from "react";
import style from '../Header/Header.module.css';

const Header = () => {
    return (
        <div className={style.containerHeader}>
            <div className={style.titleContainer}>
                <h2 className={style.title}>Hola,<br /> Soy <span>Nahuel</span> <br /> FullStack Developer</h2>
            </div>
            
            <div className={style.cvContainer}>
                <a href="https://drive.google.com/file/d/1NDaY1QC9hp9W3FBb1BN4IV9Pk5b0D25z/view?usp=drive_linkgit" target="_blank" rel="noopener noreferrer" className={style.cv}>Ver CV</a>
            </div>
        </div>
    );
};

export default Header;

